import React from "react";

import NewsJobRequestPage from "./NewsJobRequestPage";

export default function RequestReportPage() {
  return <NewsJobRequestPage mode="report" />;
}
